import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter, ElementRef } from '@angular/core';
import { login_formModel } from './login_form.model';
import { TextBoxComponent } from '../../../text-box/text-box.component';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { PasswordComponent } from '../../../password/password.component';
import { SocketioService } from 'src/app/socketio.service';

const customCss: string = '';
@Component({
    selector: 'app-login_form',
    templateUrl: './login_form.component.html'
})
export class login_formComponent extends FormComponent implements OnInit, AfterViewInit {
    @ViewChild('FieldId_1', { static: false }) FieldId_1: ElementRef;
    @ViewChild('txtUserName', { static: false }) txtUserName: TextBoxComponent;
    @ViewChild('txtPassword', { static: false }) txtPassword: PasswordComponent;
    @ViewChild('Logonbtn', { static: false }) Logonbtn: ButtonComponent;
    skeletonContentLoaded = false;
    @Output() loginPageLink = new EventEmitter<String>();

    async revalidate(): Promise<number> {
        var totalErrors = 0;
        super.beforeRevalidate();
        await Promise.all([
            this.revalidateBasicField('txtUserName'),
            this.revalidateBasicField('txtPassword'),
        ]).then((errorCounts) => {
            errorCounts.forEach((errorCount) => {
                totalErrors += errorCount;
            });
        });
        this.errors = totalErrors;
        super.afterRevalidate();
        return totalErrors;
    }
    constructor(services: ServiceStock) {
        super(services);
        this.value = new login_formModel();
        this.componentCode = 'login_form';
    }
    setReadOnly(readOnly) {
        super.setBasicFieldsReadOnly(readOnly);
    }
    async onFormLoad() {
        this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
        // Programmatic focus on load breaks tap-to-focus / keyboard on many mobile browsers (iOS/WebKit).
        const coarsePointer = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
        const hasTouch = typeof window !== 'undefined' && ('ontouchstart' in window || (navigator as any).maxTouchPoints > 0);
        if (!coarsePointer && !hasTouch) {
            this.txtUserName.setFocus(true);
        }
        this.setDependencies();
    }
    setInputs(param: any) {
        let params = this.services.http.mapToJson(param);
        if (params['mode']) {
            this.mode = params['mode'];
        }
    }
    async submitForm(path, apiCode, serviceCode) {
        this.submitData['formName'] = 'loginNew';
        await super.submit(path, apiCode, serviceCode);
    }
    getFieldInfo() {
        this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        return this.additionalInfo;
    }
    getFieldValue() {
        return this.value;
    }
    setValue(inputValue, inputDesc = undefined) {
        this.setBasicFieldsValue(inputValue, inputDesc);
        this.value = new login_formModel();
        this.value.setValue(inputValue);
        this.setDependencies();
        this.passNewValue(this.value);
    }
    ngOnInit() {
        if (this.formCode == undefined) { this.formCode = 'login_form'; }
        if (this.formOnLoadError) { return; }
        setTimeout(() => {
            this.skeletonContentLoaded = true;
        }, 1000);
        var styleElement = document.createElement('style');
        styleElement.type = 'text/css';
        styleElement.innerHTML = customCss;
        styleElement.id = 'login_form_customCss';
        document.getElementsByTagName('head')[0].appendChild(styleElement);
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        var styleElement = document.getElementById('login_form_customCss');
        styleElement.parentNode.removeChild(styleElement);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.subsBFldsValueUpdates();
            this.onFormLoad();
            this.checkForHTabOverFlow();
        });
    }
    clearError() {
        super.clearBasicFieldsError();
        super.clearHTabErrors();
        super.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
    }
    onReset() {
        super.resetBasicFields();
        this.clearHTabErrors();
        this.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
        this.additionalInfo = undefined;
        this.dependencyMap.clear();
        this.value = new login_formModel();
        this.passNewValue(this.value);
        this.setReadOnly(false);
        this.onFormLoad();
    }
    loginPageClick(linkClicked) {
        this.loginPageLink.emit(linkClicked);
    }

    loginData() {
        this.services.http.sessionValid = true;
        this.services.authService.newUserValue = "22510001";
        var navPath = ('/home').split('/');
        navPath = navPath.slice(1);
        let inputMap = new Map();
        this.services.dataStore.setRouteParams(this.services.routing.currModal, inputMap);
        if (this.services.routing.currModal > 0) {
            var routerOutlets = {};
            routerOutlets[this.services.routing.currOutlet] = [navPath[navPath.length - 1], 'popup'];
            this.services.http.hideSpinner();
            this.services.router.navigate([{ outlets: routerOutlets }], { skipLocationChange: true });
        } else {
            this.services.http.hideSpinner();
            this.services.router.navigate(navPath);
        }
    }

    async Logonbtn_click() {
        let inputMap = new Map();
        this.Logonbtn.setFocus(true);
        var errorCount: number = await this.revalidate();

        /************************************************************
         * 
         * //for testing - delete below
         * 
         *************************************************************/
        // this.loginData();
        /************************************************************
         * 
         * //for testing - delete above
         * 
         *************************************************************/
        document.getElementById('errMsgDiv').innerHTML = "";
        // var linkClicked = "passwordChange";
        // this.loginPageLink.emit(linkClicked);
        if (errorCount == 0) {
            this.services.http.showSpinner();
            inputMap.clear();
            inputMap.set('Body.loginid', this.txtUserName.getFieldValue());
            inputMap.set('Body.lang1', "EN");
            inputMap.set('Body.deviceType', "browser");
            inputMap.set('Body.password', this.txtPassword.getFieldValue());
            this.services.http.UnAuthorizationfetchApi('/auth', 'POST', inputMap).subscribe(
                async (httpResponse: HttpResponse<any>) => {
                    var res = httpResponse.body;
                    var respCode: any = res['respCode'];
                    if (respCode != null && respCode == "-3") {
                        var linkClicked = "passwordChange";
                        this.loginPageLink.emit(linkClicked);
                    }
                    else if (respCode != null && respCode != 0) {
                        this.services.http.hideSpinner();
                        //document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
			//commented by Shanmuga Priya - VAPT
			const rawMsg = res['errMsg'];
			const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
			(document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;
                    }
                    else if (respCode != null && respCode == 0) {
                        if (res['target'] == "IWS") {
                            this.services.http.sessionValid = true;
                            this.services.authService.newUserValue = this.txtUserName.getFieldValue();
                            var navPath = ('/home').split('/');
                            navPath = navPath.slice(1);
                            inputMap.clear();
                            this.services.dataStore.setRouteParams(this.services.routing.currModal, inputMap);
                            if (this.services.routing.currModal > 0) {
                                var routerOutlets = {};
                                routerOutlets[this.services.routing.currOutlet] = [navPath[navPath.length - 1], 'popup'];
                                this.services.http.hideSpinner();
                                this.services.router.navigate([{ outlets: routerOutlets }], { skipLocationChange: true });
                            } else {
                                this.services.http.hideSpinner();
                                this.services.router.navigate(navPath);
                            }
                            // document.getElementById('errMsgDiv').innerHTML = "Investor login temporarily unavailable";
                        } else {
                            this.services.http.hideSpinner();
                            // document.getElementById('errMsgDiv').innerHTML = "Redirect to back office";
                            window.location.href = res['target'];
                        }
                    } else {
                        document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
                    }
                    this.services.http.hideSpinner();
                },
                async (httpError) => {
                    var err = httpError['error']
                    if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
                        if (err['ErrorElementPath'] == 'password') {
                            this.txtPassword.setError(err['ErrorDescription']);
                        }
                        else if (err['ErrorElementPath'] == 'loginid') {
                            this.txtUserName.setError(err['ErrorDescription']);
                        }
                    }
                    document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
                    this.services.http.hideSpinner();
                }
            );
        }
        // this.services.http.hideSpinner();
    }
    transalte(text) {
        return this.services.translate.instant(text);
    }
    fieldDependencies = {
    }
}